(function () {

    function heroPictureZoom() {
        document.querySelectorAll('[data-js="hero-picture"]').forEach(function (picture) {
            const img = picture.querySelector('img.photo');

            if (!img) return;

            function setLoaded() {
                picture.classList.add('is-loaded');
            }

            if (img.complete) {
                setLoaded();
                return;
            }

            img.addEventListener('load', function () {
                setLoaded();
            }, { once: true });

        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', heroPictureZoom);
    } else {
        heroPictureZoom();
    }


})();